import { useEffect, useRef, useState } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { ButtonText } from '@morressier/alembic';

interface ExpandableTextProps {
  text: string;
}

export const ExpandableText = ({ text }: ExpandableTextProps) => {
  const textRef = useRef<HTMLParagraphElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    const element = textRef.current;

    if (!element) {
      return;
    }

    const checkOverflow = () => {
      setHasMore(element.scrollHeight > element.clientHeight);
    };

    const frameId = requestAnimationFrame(checkOverflow);

    return () => cancelAnimationFrame(frameId);
  }, [text]);

  return (
    <Box>
      <Text
        ref={textRef}
        textStyle="textContext"
        display="-webkit-box"
        overflow={expanded ? 'visible' : 'hidden'}
        css={{
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: expanded ? 'unset' : 2
        }}
      >
        {text}
      </Text>

      {hasMore && (
        <ButtonText
          variant="plain"
          padding={0}
          lineHeight={0}
          size="sm"
          height={6}
          ml={1}
          onClick={() => setExpanded(prev => !prev)}
         fontSize={'small'}
        >
          {expanded ? 'Show less' : 'Show more...'}
        </ButtonText>
      )}
    </Box>
  );
};